// extracted by mini-css-extract-plugin
export default {"container":"BigLoadingModal_container__iWE2d","message":"BigLoadingModal_message__Rrsmz"};